export default {
  getAccountCash: '/courier/api/financial/find/cash/account',
  toWithDrawal: '/courier/api/financial/withdrawal/request',
  helpBuyToWithDrawal: '/v3/helpBuy/withdrawal',
  queryWithdrawBankCard: '/courier/api/v3/queryWithdrawBankCard'
}
